module.exports = __webpack_public_path__ + "static/media/auction-collect-t3.c11e9f79.nom";